import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '../../user/user.service';
import { UserSettings } from '../../../shared/models/User';

@Injectable()
export class QualityGuard  {
    constructor(private router: Router, private userService: UserService) { }

    canActivate(): Observable<boolean> {
        const user: UserSettings = this.userService.getCurrentSettings();

        if (user.IsSingleSiteUser && user.DefaultSiteId !== undefined) {
            this.router.navigate(['water-quality-iq/siteView/', user.DefaultSiteId]);
        } else {
            return of(true);
        }
    }
}